import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import introImg from "../../assets/Manufacturing-background-1-1-1024x576.png";
import bgImage from "../../assets/bgimage.avif";
const Introduction = () => {
  return (
    <div
      className="py-5 position-relative"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        overflow: "hidden",
      }}
    >
      {/* Black Overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.6)",
          zIndex: 1,
        }}
      ></div>

      {/* Content */}
      <Container style={{ position: "relative", zIndex: 2, color: "#fff" }}>
        <Row className="align-items-center">
          <Col md={6}>
            <h2 className="text-center mb-4" data-aos="zoom-in">
              <span className="title-font">
                Smart Print Service & ERP Ecosystem
              </span>
            </h2>

            <p className="mb-3" data-aos="zoom-in" data-aos-delay="100">
              We don’t just service your printers – we transform the way you
              manage them.
            </p>
            <p className="mb-3" data-aos="zoom-in" data-aos-delay="200">
              EHSAS is a smart, cloud-based Managed Print Services (MPS) and ERP
              platform that brings transparency, efficiency, and real-time
              control to your printing infrastructure.
            </p>
            <ul className="mb-3" data-aos="zoom-in" data-aos-delay="300">
              <li>Systematic & Scheduled Service Management</li>
              <li>Live Reporting & Performance Monitoring</li>
              <li>Authenticity with Serialized Part Tracking</li>
              <li>Seamless Integration of Sales, Support & Inventory</li>
            </ul>
            <p data-aos="zoom-in" data-aos-delay="400">
              Whether it's a single printer or a nationwide fleet, EZYMPS
              ensures zero downtime, data-backed decisions, and full operational
              visibility—all through one intelligent dashboard.
            </p>
          </Col>
          {/* <Col md={6} data-aos="zoom-in" className="text-center">
            <img
              src={introImg}
              alt="Smart Print Service"
              className="img-fluid"
              style={{
                width: "300px",
                height: "300px",
                objectFit: "cover",
                borderRadius: "50%",
                border: "10px solid white",
              }}
            />
          </Col> */}
        </Row>
      </Container>
    </div>
  );
};

export default Introduction;
